export default {
  actions: {
    createOrder: {
      removeMedicine: 'remove-medicine',
      create: 'create-order',
      clearCreateError: 'clear-create-error',
      ccSelectPharmacy: 'cc-select-pharmacy',
      ccConfirmPharmacy: 'cc-confirm-pharmacy',
    },
    confirmExempt: 'confirm-exempt',
    logout: 'logout',
    checkout: {
      uploadEvidence: 'checkout-upload-evidence',
      skipEvidence: 'checkout-skip-evidence',
      selectExemption: 'select-exemption',
      clearExemptionSelectionError: 'clear-exemption-selection-error',
      skipUpload: 'skip-upload',
      clearDeclarationError: 'clear-exemption-declaration-error',
      pay: 'checkout-pay',
      paymetsummary: 'payment-summary',
      paymentdeliverypreference: 'payment-delivery-preference',
      clearCCStore: 'clear-cc-store',
    },
    signup: {
      setFullName: 'set-full-name',
      setPassword: 'set-password',
      verifyEmail: 'verify-email',
      setAddress: 'set-address',
      setPhoneAndDOB: 'set-phone-and-dob',
      searchGP: 'search-gp',
      validateGP: 'validate-gp',
      clearGPError: 'signup-clear-gp-error',
      activateAcccount: 'signup-activate-account',
      clearActivationError: 'signup-clear-activation-error',
    },
    orders: {
      changeDeliveryAddress: 'change-delivery-address',
      setDeliveryPref: 'set-delivery-pref',
      ccSelectPharmacy: 'cc-select-pharmacy',
    },
  },
};
